var map = {
	"./advanced/advanced.module": [
		"./src/app/pages/advanced/advanced.module.ts",
		"advanced-advanced-module"
	],
	"./company/company.module": [
		"./src/app/pages/company/company.module.ts",
		"company-company-module"
	],
	"./miscellaneous/miscellaneous.module": [
		"./src/app/pages/miscellaneous/miscellaneous.module.ts",
		"common"
	],
	"./monitor/monitor.module": [
		"./src/app/pages/monitor/monitor.module.ts",
		"monitor-monitor-module"
	],
	"./traffic/traffic.module": [
		"./src/app/pages/traffic/traffic.module.ts",
		"traffic-traffic-module"
	],
	"./user/user.module": [
		"./src/app/pages/user/user.module.ts",
		"user-user-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"common",
		"app-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;